export const deleteSpeedManagmentService = (fetch) => async (id) => {
  try {
    const response = await fetch({
      url: `/api/v1/gestion-velocidad/${id}`,
      method: "delete",
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
